export default __webpack_public_path__ + "static/media/clients-view.0f812708.png";